import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { xapi } from '../../hooks/session';
import { IEmp } from '../../models/emp';
import { throwError } from '../helper';

/*
 * Rank
 */
export const getPortalReadRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/${data.type}/rank/read?educationOfficeSeq=${data.educationOfficeSeq}&month=${data.month}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalWalkRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/${data.type}/rank/walk?educationOfficeSeq=${data.educationOfficeSeq}&month=${data.month}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalWriteRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/${data.type}/rank/write?educationOfficeSeq=${data.educationOfficeSeq}&month=${data.month}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const downloadPortalRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/${data.type}/rank/${data.subType}/download?educationOfficeSeq=${data.educationOfficeSeq}&month=${data.month}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'portal_stat_rank.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

/*
 * Statistics
 */

export const getPortalMonthlyReadStatList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/monthly-stat/read?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalMonthlyWalkStatList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/monthly-stat/walk?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalMonthlyWriteStatList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/monthly-stat/write?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalMonthlyReadMedalList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/monthly-medal/read?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalMonthlyWalkMedalList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/monthly-medal/walk?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalMonthlyWriteMedalList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/monthly-medal/write?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalMonthlySchoolGroupReadStatList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/monthly-stat/school-group/read?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalMonthlySchoolGroupWalkStatList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/monthly-stat/school-group/walk?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalMonthlySchoolGroupWriteStatList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/monthly-stat/school-group/write?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalReadAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/achievement-stat/read?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalWalkAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/achievement-stat/walk?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalWriteAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/achievement-stat/write?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalDailyReadAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/daily-achievement-stat/read?year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalDailyWalkAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/daily-achievement-stat/walk?year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalDailyWriteAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/daily-achievement-stat/write?year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalMonthlyReadAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/achievement-data/read?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalMonthlyWalkAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/achievement-data/walk?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalMonthlyWriteAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/achievement-data/write?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalDailyReadAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/daily-achievement-data/read?year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalDailyWalkAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/daily-achievement-data/walk?year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalDailyWriteAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/daily-achievement-data/write?year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getPortalMonthlyStatData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/monthly-stat-data?year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const downloadPortalMonthlyDataList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/monthly-stat/${data.type}/${data.dataType}/download?year=${data.year}&month=${data.month}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'portal_monthly_rank.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

export const downloadPortalMonthlyMedalDataList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/monthly-medal/${data.type}/${data.dataType}/download?year=${data.year}&month=${data.month}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'portal_monthly_medal.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

export const downloadPortalSchoolGroupMonthlyDataList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/monthly-stat/school-group/${data.type}/${data.dataType}/download?year=${data.year}&month=${data.month}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'portal_school_group_monthly_rank.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

/*
 * Log Manage
 */
export const getPortalWriteList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/all-write-status?page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const downloadPortalWriteList = async (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/portal-stat/all-write-status/download?page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'portal_stat_log.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });
